import * as React from "react"

import { cn } from "@/lib/utils"
import persianJs from "@/lib/persian"

interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
    currency?: boolean,
    phone?: boolean,
  }

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type,value, onChange,currency = false,phone, ...props }, ref) => {

    let maskProps: InputProps = {
      type,
      value, 
      onChange,
      autoComplete: "off"
    }

    if (currency && (onChange !== undefined && value !== undefined)) {
      maskProps.type = 'tel'
      const format = Intl.NumberFormat('fa').format
      const on = onChange as React.ChangeEventHandler<HTMLInputElement>
      maskProps.value = value == 0 ? '' :format(Number(value))
      maskProps.onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (isDigitsOnly(event.target.value.replaceAll('٬', ''))) {
        event.target.value = persianJs(String(event.target.value).replaceAll('٬', '')).persianNumber().value().replace(/\D/g, '')
        on(event)
        return
        } else {
          event.preventDefault()
        }
      }
    }

    const isDigitsOnly = (text: string) => {
      // الگوی منظم برای تطبیق اعداد انگلیسی، فارسی و عربی
      const digitPattern = /^[0-9۰-۹٠-٩]*$/;
      return digitPattern.test(text);
    };

    if (phone) {
      maskProps.onKeyDown = (e) => {
        // لیست کلیدهای مجاز
    const allowedKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 
      'Home', 'End', 'Tab', 'Enter', 'Escape'
    ];
    
    // اعداد عددی در کیبورد اصلی
    const numberKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    
    // اعداد کیپد عددی
    const numpadKeys = ['Numpad0', 'Numpad1', 'Numpad2', 'Numpad3', 'Numpad4', 
                        'Numpad5', 'Numpad6', 'Numpad7', 'Numpad8', 'Numpad9'];
    
    // کلیدهای کنترلی مثل Ctrl+A، Ctrl+C، Ctrl+V، Ctrl+X
    const isCtrlCombination = e.ctrlKey || e.metaKey;
    
    // اگر کلید مجاز یا ترکیب کنترلی نیست و عدد هم نیست
    if (!allowedKeys.includes(e.key) && 
        !numberKeys.includes(e.key) && 
        !numpadKeys.includes(e.code) && 
        !isCtrlCombination) {
      e.preventDefault();
    }
      }

      maskProps.onPaste = (e) => {
        const pastedText = e.clipboardData.getData('text');
        console.log(pastedText, e)

        if (!isDigitsOnly(pastedText)) {
          e.preventDefault()
          return
        }

        if (pastedText.startsWith('9')) {
          const phoneNumber = pastedText.split("")
          phoneNumber.unshift('0')
          // @ts-ignore
          maskProps.onChange?.({target: {value: phoneNumber.join("")}})

        } else {

          // @ts-ignore
          maskProps.onChange?.({target: {value: pastedText}})
        }

      }
      
    }

    

    return (
      <input
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...maskProps}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
